export interface MandateErrorHandlerOptions {
  /**
   * Whether this is the success page. Success page should handle
   * 412 errors gracefully since the user has already completed the flow.
   */
  isSuccessPage?: boolean;
}

export interface MandateError {
  status: number;
  data?: { errors?: { code?: string }[] };
}

export function createMandateErrorHandler(options: MandateErrorHandlerOptions = {}) {
  const { isSuccessPage = false } = options;

  return (error: unknown) => {
    // Handle invalid errors
    if (!error || typeof error !== 'object') {
      throw new Error('generic_error');
    }

    const mandateError = error as MandateError;
    const status = mandateError.status;
    const errorCode = mandateError.data?.errors?.[0]?.code;

    // For success page, only ignore "mandate_already_signed" errors
    if (isSuccessPage && status === 412 && errorCode === 'mandate_already_signed') {
      return;
    }

    // Handle specific HTTP error status codes
    if (typeof status === 'number' && [400, 404, 412].includes(status)) {
      const errorType =
        errorCode === 'payment_link_expired' ? 'mandate_expired' : 'mandate_invalid';
      throw new Error(errorType);
    }

    // For all other errors
    throw new Error('generic_error');
  };
}
